import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useLanguage } from '../contexts/LanguageContext.jsx';
import { useStore } from '../src/contexts/StoreContext.jsx';
import { trackEvent } from '../services/analytics.js';
import { Sym } from './ui.jsx';

export const LanguageSwitcher = observer(() => {
  const { language, setLanguage } = useLanguage();
  const { localizationStore } = useStore();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const locales = localizationStore.availableLocales;

  useEffect(() => {
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, []);

  const change = (code) => { setLanguage(code); setOpen(false); trackEvent('language_changed', { language_code: code }); };

  return (
    <div className="lang" ref={ref}>
      <button type="button" className="glass-pill" onClick={() => setOpen(!open)} aria-haspopup="listbox" aria-expanded={open}>
        <Sym name="translate" size={18} />{language.toUpperCase()}
      </button>
      {open && (
        <div className="lang-menu" role="listbox">
          {locales.map((l) => (
            <button type="button" key={l.code} role="option" aria-selected={language === l.code} className={'lang-item' + (language === l.code ? ' active' : '')} onClick={() => change(l.code)}>
              <span style={{ fontSize: 18 }}>{l.flag}</span><span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
});

